var _rect, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 768,
    viewBox: "0 0 1366 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1366 -4.17969H0V906H1366V-4.17969Z",
    fill: "url(#paint0_linear_2263_2357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1366 327.126C1366 327.126 1212.1 176.036 1090.07 430.886C968.039 685.737 812.133 902.723 594.665 718.503C188.508 374.455 0 649.329 0 649.329V906H1366V327.126Z",
    fill: "url(#paint1_linear_2263_2357)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M612.879 -6C612.879 -6 401.604 301.641 866.044 492.778C1330.48 683.916 1259.45 906 1259.45 906H1366V-4.17964L612.879 -6Z",
    fill: "url(#paint2_linear_2263_2357)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M569.167 370.632C739.279 479.308 962.21 418.508 1087.7 282.527C1263.82 91.7532 1366 192.419 1366 192.419V660.251C1366 660.251 1129.77 374.455 831.439 605.641C417.996 926.024 0 683.916 0 683.916V103.222C0 103.222 275.386 -41.8611 439.306 233.013C475.914 294.359 520.355 339.504 569.167 370.632Z",
    fill: "url(#paint3_linear_2263_2357)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.85 -4.17969C1071.85 -4.17969 1188.97 393.205 656.044 322.939C123.122 252.673 0 594.354 0 594.354V-4.17969H1071.85Z",
    fill: "url(#paint4_linear_2263_2357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2263_2357",
    x1: 683,
    y1: -78.8144,
    x2: 683,
    y2: 1044.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1378,
    stopColor: "#3BA5B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3256,
    stopColor: "#3885CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#3680C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6484,
    stopColor: "#2B669D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8672,
    stopColor: "#245684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22507B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2263_2357",
    x1: 657.025,
    y1: 486.379,
    x2: 782.567,
    y2: 1116.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069855,
    stopColor: "#48C3A1",
    stopOpacity: 0.9301
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3093,
    stopColor: "#65CDB0",
    stopOpacity: 0.6907
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5466,
    stopColor: "#7AD4BB",
    stopOpacity: 0.4534
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7788,
    stopColor: "#87D8C2",
    stopOpacity: 0.2212
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BD9C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2263_2357",
    x1: 960.684,
    y1: 65.882,
    x2: 1166.79,
    y2: 1099.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069855,
    stopColor: "#48C3A1",
    stopOpacity: 0.9301
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3093,
    stopColor: "#65CDB0",
    stopOpacity: 0.6907
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5466,
    stopColor: "#7AD4BB",
    stopOpacity: 0.4534
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7788,
    stopColor: "#87D8C2",
    stopOpacity: 0.2212
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BD9C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2263_2357",
    x1: 618.257,
    y1: 92.1991,
    x2: 802.656,
    y2: 1078.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1378,
    stopColor: "#3BA5B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3256,
    stopColor: "#3885CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#3680C6",
    stopOpacity: 0.9313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6484,
    stopColor: "#2B669D",
    stopOpacity: 0.5214
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8672,
    stopColor: "#245684",
    stopOpacity: 0.1969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22507B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2263_2357",
    x1: 564.988,
    y1: 495.929,
    x2: 482.644,
    y2: -97.7503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069855,
    stopColor: "#48C3A1",
    stopOpacity: 0.9301
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3093,
    stopColor: "#65CDB0",
    stopOpacity: 0.6907
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5466,
    stopColor: "#7AD4BB",
    stopOpacity: 0.4534
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7788,
    stopColor: "#87D8C2",
    stopOpacity: 0.2212
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BD9C4",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.a94acb029923444e972ad3fa5d94649e.svg";
export { ForwardRef as ReactComponent };